/*
  MacShack product page: tidies product descriptions so they read like the rest of the page.
  Descriptions are pasted from many sources (manufacturer sites, supplier sheets), so this
  - strips pasted inline styles, classes, centring, layout wrappers and empty elements
  - turns "- item" lines into real lists, bold one-liners into headings,
    and "Label: value" lines into spec rows
  - on the Overview card (products without spec fields) pulls the bold product line and the
    first feature list up into a Highlights block, and folds very long text behind "Read more".
  Nothing is changed in Shopify; this only affects how the description is shown.
*/
(function () {
  var CHECK = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  var BLOCKS = 'p, div, ul, ol, table, img, figure, h1, h2, h3, h4, h5, h6, blockquote, dl';

  function textOf(html) { var d = document.createElement('div'); d.innerHTML = html; return d.textContent.replace(/ /g, ' ').trim(); }
  function clean(t) { return (t || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim(); }
  function unwrap(el) { var p = el.parentNode; if (!p) return; while (el.firstChild) p.insertBefore(el.firstChild, el); p.removeChild(el); }
  function isLeaf(el) { return !el.querySelector(BLOCKS); }
  function boldText(el) { return clean(Array.prototype.map.call(el.querySelectorAll('strong, b'), function (b) { return b.textContent; }).join(' ')); }
  function noColon(t) { return t.replace(/\s*:\s*$/, ''); }

  function tidy(ov) {
    // Comments, stray tags, pasted attributes
    var walker = document.createTreeWalker(ov, NodeFilter.SHOW_COMMENT), comments = [];
    while (walker.nextNode()) comments.push(walker.currentNode);
    comments.forEach(function (c) { c.remove(); });
    ov.querySelectorAll('meta, script, style, link, noscript').forEach(function (e) { e.remove(); });
    // Icons pasted along with copied text (e.g. an "open link" arrow) lose their size once styles are stripped
    ov.querySelectorAll('svg').forEach(function (e) { e.remove(); });
    ov.querySelectorAll('img:not([alt])').forEach(function (e) { e.setAttribute('alt', ''); });
    ov.querySelectorAll('*').forEach(function (el) {
      el.removeAttribute('style'); el.removeAttribute('class'); el.removeAttribute('align'); el.removeAttribute('id');
      if (el.tagName !== 'IMG') { el.removeAttribute('width'); el.removeAttribute('height'); }
    });
    ov.querySelectorAll('main, section, article, span, font, center').forEach(unwrap);
    // Layout wrappers (divs that hold other blocks) add nothing but stray spacing
    ov.querySelectorAll('div').forEach(function (d) { if (d.isConnected && d.querySelector(BLOCKS)) unwrap(d); });
    ov.querySelectorAll('h1').forEach(function (h) { var n = document.createElement('h2'); n.innerHTML = h.innerHTML; h.replaceWith(n); });

    // Line breaks: pull <br> out of the end of bold labels, then split lines that start a new bold label
    ov.querySelectorAll('p, div').forEach(function (p) {
      if (!p.isConnected || !isLeaf(p) || !/<br/i.test(p.innerHTML)) return;
      var html = p.innerHTML.replace(/(\s*<br\s*\/?>\s*)+(<\/(strong|b)>)/gi, '$2<br>');
      var segs = html.split(/<br\s*\/?>/i).map(function (s) { return s.trim(); }).filter(function (s) { return textOf(s); });
      if (segs.length < 2) { p.innerHTML = html; return; }
      var startsBold = function (s) { return /^<(strong|b)[\s>]/i.test(s); };
      var firstBoldOnly = startsBold(segs[0]) && noColon(textOf(segs[0])) === noColon(boldText(Object.assign(document.createElement('div'), { innerHTML: segs[0] })));
      var laterBold = segs.slice(1).some(startsBold);
      if (!firstBoldOnly && !laterBold) { p.innerHTML = html; return; }
      var frag = document.createDocumentFragment();
      segs.forEach(function (s) { var np = document.createElement('p'); np.innerHTML = s; frag.appendChild(np); });
      p.replaceWith(frag);
    });

    // "- item" lines become lists
    var paras = Array.prototype.slice.call(ov.querySelectorAll('p, div'));
    paras.forEach(function (p) {
      if (!p.isConnected || !isLeaf(p)) return;
      var lines = p.innerHTML.split(/<br\s*\/?>/i).map(function (s) { return s.trim(); }).filter(function (s) { return textOf(s); });
      var isDash = function (l) { return /^[-–•*]\s*/.test(textOf(l)); };
      if (lines.filter(isDash).length < 3) return;
      var frag = document.createDocumentFragment(), ul = null;
      lines.forEach(function (l) {
        if (isDash(l)) {
          if (!ul) { ul = document.createElement('ul'); frag.appendChild(ul); }
          var li = document.createElement('li');
          li.innerHTML = l.replace(/^((?:\s|<[^>]+>)*)[-–•*]\s*/, '$1');
          ul.appendChild(li);
        } else {
          ul = null;
          var np = document.createElement('p'); np.innerHTML = l; frag.appendChild(np);
        }
      });
      p.replaceWith(frag);
    });
    // Runs of separate "- item" paragraphs become one list
    Array.prototype.slice.call(ov.querySelectorAll('p')).forEach(function (p) {
      if (!p.isConnected || !/^[-–•]\s+/.test(clean(p.textContent))) return;
      var run = [p], n = p.nextElementSibling;
      while (n && n.tagName === 'P' && /^[-–•]\s+/.test(clean(n.textContent))) { run.push(n); n = n.nextElementSibling; }
      if (run.length < 3) return;
      var ul = document.createElement('ul');
      run.forEach(function (r) { var li = document.createElement('li'); li.innerHTML = r.innerHTML.replace(/^((?:\s|<[^>]+>)*)[-–•]\s*/, '$1'); ul.appendChild(li); });
      p.parentNode.insertBefore(ul, p);
      run.forEach(function (r) { r.remove(); });
    });

    // Empty bits
    ov.querySelectorAll('p, div, li, h2, h3, h4, h5, figcaption, strong, b').forEach(function (el) {
      if (el.isConnected && !clean(el.textContent) && !el.querySelector('img, video, iframe, table')) el.remove();
    });
    // Lists that only hold icons
    ov.querySelectorAll('ul, ol').forEach(function (l) {
      if (!clean(l.textContent)) { var imgs = Array.prototype.slice.call(l.querySelectorAll('img')); if (imgs.length) l.replaceWith.apply(l, imgs); else l.remove(); }
      else if (l.children.length > 10) l.setAttribute('data-long', '');
    });
    ov.querySelectorAll('img').forEach(function (img) {
      var w = parseInt(img.getAttribute('width') || '0', 10);
      if (w && w < 420) img.setAttribute('data-small', '');
      img.setAttribute('loading', 'lazy');
      img.removeAttribute('width'); img.removeAttribute('height');
    });
  }

  function takeLede(ov) {
    var first = null;
    var leaves = ov.querySelectorAll('p, div, h2, h3');
    for (var i = 0; i < leaves.length; i++) { if (isLeaf(leaves[i]) && clean(leaves[i].textContent)) { first = leaves[i]; break; } }
    if (!first) return '';
    var t = clean(first.textContent);
    var bold = first.tagName.charAt(0) === 'H' ? t : boldText(first);
    if (t.length > 20 && t.length < 320 && bold === t) { first.remove(); return t; }
    return '';
  }

  function structure(ov) {
    // Bold-only short lines become headings
    ov.querySelectorAll('p, div').forEach(function (p) {
      if (!p.isConnected || !isLeaf(p)) return;
      var t = clean(p.textContent);
      if (!t || t.length > 60) return;
      if (noColon(boldText(p)) === noColon(t)) { var h = document.createElement('h3'); h.textContent = noColon(t); p.replaceWith(h); }
    });
    // "Label: value" lines become spec rows (runs of two or more)
    var rows = [];
    ov.querySelectorAll('p, div').forEach(function (p) {
      if (!p.isConnected || !isLeaf(p)) return;
      var b = p.querySelector('strong, b');
      if (!b || p.firstElementChild !== b) return;
      var label = clean(b.textContent), all = clean(p.textContent);
      if (all.indexOf(label) !== 0) return;
      var rest = clean(all.slice(label.length));
      if (!/:$/.test(label) && !/^:/.test(rest)) return;
      var value = rest.replace(/^:\s*/, '');
      if (!value || all.length > 220) return;
      rows.push({ el: p, label: noColon(label), value: value });
    });
    var i = 0;
    while (i < rows.length) {
      var run = [rows[i]];
      while (i + run.length < rows.length && run[run.length - 1].el.nextElementSibling === rows[i + run.length].el) run.push(rows[i + run.length]);
      if (run.length >= 2) {
        var dl = document.createElement('dl');
        dl.setAttribute('data-specs', '');
        run.forEach(function (r) {
          var row = document.createElement('div');
          var dt = document.createElement('dt'); dt.textContent = r.label;
          var dd = document.createElement('dd'); dd.textContent = r.value;
          row.appendChild(dt); row.appendChild(dd); dl.appendChild(row);
        });
        run[0].el.parentNode.insertBefore(dl, run[0].el);
        run.forEach(function (r) { r.el.remove(); });
      }
      i += run.length;
    }
  }

  function takeHighlights(ov) {
    var lists = ov.querySelectorAll('ul');
    for (var i = 0; i < lists.length; i++) {
      var items = Array.prototype.slice.call(lists[i].children).filter(function (li) { return li.tagName === 'LI'; });
      if (items.length < 3 || items.length > 12 || lists[i].querySelector('img, ul, ol')) continue;
      var texts = items.map(function (li) { return clean(li.textContent); });
      if (texts.some(function (t) { return t.length < 6 || t.length > 260; })) continue;
      var prev = lists[i].previousElementSibling;
      if (prev && /^H[2-4]$/.test(prev.tagName) && /feature|highlight|key/i.test(prev.textContent)) prev.remove();
      lists[i].remove();
      return texts;
    }
    return [];
  }

  function story(ov) {
    var card = ov.parentNode, box = null;
    var lede = takeLede(ov);
    structure(ov);
    var hl = takeHighlights(ov);
    if (lede || hl.length) {
      box = document.createElement('div');
      box.className = 'msp-hl';
      var html = '';
      if (lede) html += '<p class="msp-hl__lede"></p>';
      if (hl.length) html += '<p class="msp-hl__t">Highlights</p><ul class="msp-hl__list">' + hl.map(function () { return '<li>' + CHECK + '<span></span></li>'; }).join('') + '</ul>';
      box.innerHTML = html;
      if (lede) box.querySelector('.msp-hl__lede').textContent = lede;
      box.querySelectorAll('.msp-hl__list span').forEach(function (s, k) { s.textContent = hl[k]; });
      card.insertBefore(box, ov);
    }
    // A leading "Description" heading adds nothing under "About this product"
    var firstEl = ov.firstElementChild;
    if (box && firstEl && /^H[2-4]$/.test(firstEl.tagName) && /^(description|product description|overview)$/i.test(clean(firstEl.textContent))) firstEl.remove();
    // On phones a long Highlights list shows its first 3 points; the rest open with "Read more"
    var trimHl = !!box && hl.length > 3 && window.matchMedia('(max-width: 749px)').matches;
    var noText = !clean(ov.textContent) && !ov.querySelector('img, table, video');
    if (noText) {
      ov.hidden = true;
      if (box) { box.style.borderBottom = '0'; box.style.marginBottom = '0'; box.style.paddingBottom = '0'; }
      if (!trimHl) return;
    } else {
      if (box) { var sep = document.createElement('p'); sep.className = 'msp-hl__t msp-hl__t--story'; sep.textContent = 'About this product'; card.insertBefore(sep, ov); }
      ov.classList.add('msp-story');
    }
    requestAnimationFrame(function () {
      // Short by default: about 8 lines under the highlights, about 12 when the text stands alone
      var limit = box ? 240 : 380;
      var tall = !noText && ov.scrollHeight >= limit + 140;
      if (!tall && !trimHl) return;
      var open = false;
      var shut = function () {
        if (tall) { ov.classList.add('is-collapsed'); ov.style.maxHeight = limit + 'px'; }
        if (trimHl) box.classList.add('is-trim');
      };
      var show = function () {
        ov.classList.remove('is-collapsed'); ov.style.maxHeight = '';
        if (box) box.classList.remove('is-trim');
      };
      shut();
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'msp-more msp-story-more';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', ov.id);
      btn.innerHTML = '<span>Read more</span><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
      btn.addEventListener('click', function () {
        open = !open;
        if (open) show(); else shut();
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.querySelector('span').textContent = open ? 'Show less' : 'Read more';
        if (!open) card.scrollIntoView({ block: 'start' });
      });
      if (noText) box.after(btn); else ov.after(btn);
    });
  }

  function run() {
    document.querySelectorAll('.ms-product .msp-overview:not([data-tidy])').forEach(function (ov) {
      ov.setAttribute('data-tidy', '');
      try {
        tidy(ov);
        if (ov.closest('.msp-specs--prose')) story(ov); else structure(ov);
      } catch (e) { console.error('ms-product-story', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
